export default function ({ headers = {}, query = {} }) {
    const whitelistedHeaders = [
        'uuid',
        'cid',
        'authorization',
        'wixsession2',
        'cookie',
    ];
    const isWhitelisted = (loweCaseName) => loweCaseName.indexOf('x-wix') === 0 ||
        whitelistedHeaders.includes(loweCaseName);
    const forwardHeaders = {};
    for (const headerName in headers) {
        const lowerCaseHeaderName = headerName.toLowerCase();
        if (headers.hasOwnProperty(headerName) &&
            isWhitelisted(lowerCaseHeaderName)) {
            forwardHeaders[lowerCaseHeaderName] = headers[headerName];
        }
    }
    const RequestIdHeaderName = 'x-wix-request-id';
    const RequestIdParamName = 'request_id';
    if (query && query[RequestIdParamName]) {
        if (!forwardHeaders[RequestIdHeaderName]) {
            forwardHeaders[RequestIdHeaderName] = query[RequestIdParamName];
        }
    }
    return forwardHeaders;
}
//# sourceMappingURL=extract-forward-headers.js.map